import moment from "moment";

export const queryDateFormatToDate = (date) => {
  const yearDate = Math.floor(moment(date).format("YYYY"));
  const monthDate = Math.floor(moment(date).format("MM") - 1);
  const dayDate = Math.floor(moment(date).format("DD"));
  const formattedDate = new Date();
  formattedDate.setFullYear(yearDate);
  formattedDate.setMonth(monthDate);
  formattedDate.setDate(dayDate);

  return formattedDate;
};
